import React from 'react';

import styled from 'styled-components';

import { Button } from 'apps/auth/components/common/Button/Button';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const QrCode = styled.div`
    display: inline-flex;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.grey_28_tr};
`;
const TextContainer = styled.div`
    max-width: 316px;
    margin: 0 auto;
`;

const DownloadAppPopup = (props) => {
    const messages = usePageMessages();
    const { gotIt, downloadTheApp, scanWithCamera, transferNotSupported } = props.messages || messages;

    const extra = useExtra();
    const { appLink } = props.extra || extra;

    return (
        <ComplexPopup withoutButton withoutCloseButton popupRef={props.popupRef}>
            <Text color={'primary'} variant={'div'} indent={'adaptive-32-48'} textAlign={'center'}>
                {transferNotSupported}
            </Text>
            <Row indent={'adaptive-16-24'} textAlign={'center'}>
                <QrCode>
                    <img src={`${URL_IMAGES_I}/qr-code-download-app.svg`} alt="qr-code" />
                </QrCode>
            </Row>
            <TextContainer>
                <Text color={'secondary'} variant={'div'} size={'secondary'} indent={'adaptive-32-48'} textAlign={'center'}>
                    {scanWithCamera}
                </Text>
            </TextContainer>
            <Row indent={'adaptive-16-24'}>
                <Button type={'link'} href={appLink} variant="row" caption={downloadTheApp} textCenter size={'tight'} />
            </Row>
            <Button
                type={'button'}
                variant="row"
                caption={gotIt}
                textCenter
                size={'tight'}
                onClick={() => {
                    props?.onClick();
                }}
            />
        </ComplexPopup>
    );
};

export default DownloadAppPopup;
